const COMPRESSION_THRESHOLD_BYTES = 200 * 1024;

function uint8ArrayToBase64(bytes: Uint8Array): string {
  let binary = "";
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

/**
 * Compresses a JSON string with gzip if it exceeds the threshold (200KB).
 * Returns the original string if below threshold or if CompressionStream is unavailable.
 * When compressed, returns a base64-encoded string for safe JSON transport.
 */
export async function compressIfNeeded(jsonString: string): Promise<{
  value: string;
  isCompressed: boolean;
}> {
  const encoder = new TextEncoder();
  const bytes = encoder.encode(jsonString);

  if (bytes.byteLength <= COMPRESSION_THRESHOLD_BYTES) {
    return { value: jsonString, isCompressed: false };
  }

  if (typeof CompressionStream === "undefined") {
    return { value: jsonString, isCompressed: false };
  }

  const stream = new Blob([bytes]).stream().pipeThrough(new CompressionStream("gzip"));
  const compressedBlob = await new Response(stream).blob();
  const arrayBuffer = await compressedBlob.arrayBuffer();
  const base64 = uint8ArrayToBase64(new Uint8Array(arrayBuffer));
  return { value: base64, isCompressed: true };
}
